import {ROUTES} from 'constants/routes.constant'

const appConfig = {
    apiPrefix: `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_VERSION}`,
    authenticatedEntryPath: ROUTES.USER_MANAGEMENT,
    unAuthenticatedEntryPath: ROUTES.SIGN_IN,
    externalRoutes: [
        ROUTES.TERM_OF_USE,
        ROUTES.PRIVACY_POLICY,
        ROUTES.GREETING,
        // Deep-link fallback prefixes — Layout uses these to detect when
        // a request is a deep-link path that should render ExternalRoutesLayout
        // (no admin chrome) instead of the admin AuthLayout. Layout match logic
        // upgraded from `.includes(pathname)` to startsWith-aware so dynamic
        // segments like /workout/123 match the /workout prefix.
        ROUTES.DEEP_LINK_WORKOUT_PREFIX,
        ROUTES.DEEP_LINK_PROGRAM_PREFIX,
        ROUTES.DEEP_LINK_CLUB_PREFIX,
        ROUTES.DEEP_LINK_EVENT_PREFIX,
        ROUTES.DEEP_LINK_PROFILE_PREFIX,
        ROUTES.DEEP_LINK_SHARE_PREFIX,
        ROUTES.DEEP_LINK_RESET_PASSWORD,
    ],
}

export default appConfig
